import { Component } from "@angular/core";
import { NgForm } from "@angular/forms";
// import { Form } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import {Filing, Form, FormFilter, FormState, FormType} from "src/api/models";
import { FilingService } from "src/api/services";
import { handlePasteWithoutLeadingSpaces, preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-discard",
  // imports: [],
  templateUrl: "./discard.component.html",
  styleUrl: "./discard.component.css",
  standalone: false,
})
export class DiscardComponent {
  filings: Form[] = [];
  first = 0;
  isLoading: boolean = false;
  rows = 10;
  filingIdInput?: number;
  issuerNameInput?: string;
  formTypes = FormType.values();
  formStates = [
    { label: 'Manual', value: FormState.MANUAL_CHECK },
    { label: 'LLM', value: FormState.UNPROCESSED },
    { label: 'Processed', value: FormState.PROCESSED }
  ];
  selectedFormType: FormType | null = null;
  selectedFormState: FormState | null = null;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  rangeDates: Date[] | undefined;
  startDateInput?: Date | string;
  endDateInput?: Date | string;
  constructor(
    private _filingService: FilingService,
    private _messageService: MessageService,
    private _confirmationService: ConfirmationService
  ) {}
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getFilingWithFilingFilter();
  }
  onDateChange() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      const formatDate = (date: Date) => date.toLocaleDateString("en-CA"); // yyyy-mm-dd (local)

      this.startDateInput = formatDate(this.rangeDates[0]);
      this.endDateInput = formatDate(this.rangeDates[1]);

      this.onSearch();
    } else {
      this.startDateInput = undefined;
      this.endDateInput = undefined;
      this.onSearch();
    }
  }
 onSearch(form?: NgForm) {
  if (form && form.invalid) {
    form.control.markAllAsTouched();
    return;
  }

  this.first = 0;
  this.paginator.pageNumber = 1;
  this.getFilingWithFilingFilter();
}


  getFilingWithFilingFilter() {
     const cleanedIssuerName =
    typeof this.issuerNameInput === 'string'
      ? this.issuerNameInput.trim()
      : this.issuerNameInput;
    const params: FormFilter = {
      formState: "DISCARD",
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      filingId: this.filingIdInput,
      issuerName: cleanedIssuerName,
      formType: this.selectedFormType as any,
      prevFormSate: this.selectedFormState as any,
      startDate:
        this.startDateInput instanceof Date
          ? this.startDateInput.toISOString()
          : this.startDateInput,
      endDate:
        this.endDateInput instanceof Date
          ? this.endDateInput.toISOString()
          : this.endDateInput,
    };
    this.isLoading = true;
    this._filingService.getFilings(params).subscribe({
      next: (value) => {
        this.filings = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.filings.length > 0 ? this.filings[0].totalCount! : 0;
        this.isLoading = false;
      },
    });
  }
  restoreFiling(filing: any) {
    this._confirmationService.confirm({
      message: `Are you sure you want to restore filing #${filing.filingId}?`,
      header: "Confirm Restore",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.isLoading = true;
        const reason = "Filing Incorrectly Discarded";

        const params = {
          filingId: filing.filingId,
          reason: reason,
        };

        this._filingService.revertDiscardFiling(params).subscribe({
          next: (success) => {
            if (success) {
              this._messageService.add({
                severity: "success",
                summary: "Filing Restored",
                detail: `Filing #${filing.filingId} has been successfully restored.`,
              });
              this.getFilingWithFilingFilter();
            } else {
              this._messageService.add({
                severity: "warn",
                summary: "Failed to Restore",
                detail: `Filing #${filing.filingId} could not be restored.`,
              });
            }
          },
          error: (err) => {
            this._messageService.add({
              severity: "error",
              summary: "Error",
              detail:
                err.error.message ||
                "Something went wrong while restoring the filing.",
            });
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      },
    });
  }
    preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }
onPaste(
  event: ClipboardEvent,
  field: "issuerNameInput" | "filingIdInput"
): void {
  handlePasteWithoutLeadingSpaces(event, (newValue: string) => {

    if (field === "issuerNameInput") {
      this.issuerNameInput = newValue.trim() || undefined;
      return;
    }

    if (field === "filingIdInput") {
      const num = Number(newValue.trim());
      this.filingIdInput = Number.isNaN(num) ? undefined : num;
    }

  });
}
}
